import { z } from "zod";
import { IsoDateTimeSchema } from "./primitives.js";
// ---------------------------------------------------------------------------
// ADR-016 — per-user LLM token metering and monthly budget enforcement.
// Costs are server-computed ESTIMATES from the versioned SSM price sheet
// (FX and list-price drift) and are labeled as such on every surface.
// ---------------------------------------------------------------------------
export const LlmUsageSourceSchema = z.enum(["amy_chat", "pantry_extraction", "recipe_compose"]);
// POST /v1/usage/llm request — raw token counts only. Cost is NEVER
// client/agent-supplied: the server prices tokens itself (ADR-016 §1).
export const LlmUsageRecordRequestSchema = z.object({
    source: LlmUsageSourceSchema,
    modelId: z.string().min(1),
    inputTokens: z.number().int().nonnegative(),
    outputTokens: z.number().int().nonnegative(),
});
export const LlmUsageRecordResponseSchema = z.object({
    recorded: z.boolean(),
    estimatedCostEurCents: z.number().int().nonnegative(),
    pricingVersion: z.string(),
});
// GET /v1/usage/llm response — the calling user's calendar-month totals and
// budget state. `capExceeded` is the enforcement flag Amy/pantry check
// BEFORE any model call (fail closed on check errors).
export const LlmUsageResponseSchema = z.object({
    monthStart: IsoDateTimeSchema,
    inputTokens: z.number().int().nonnegative(),
    outputTokens: z.number().int().nonnegative(),
    estimatedCostEurCents: z.number().int().nonnegative(),
    /** Always an estimate — never presented as a billed amount. */
    costStatus: z.literal("estimated"),
    monthlyCapEurCents: z.number().int().positive(),
    capExceeded: z.boolean(),
    /** True at/above warnAtFraction (default 80%) of the cap. */
    warn: z.boolean(),
});
//# sourceMappingURL=usage.js.map